module.exports = __webpack_public_path__ + "static/media/about_bg.b0c668e4.jpg";